import React, { useContext, useEffect, useState } from "react";
import Disease from "../components/Disease";
import Diet from "../components/DietChoice";
import Height from "../components/Height";
import Weight from "../components/Weight";
import { ref, get, set } from "firebase/database";
import { db } from "../Firebase";
import { DataContext } from "../DataContext";
import GeminiDiet from "../ai/GeminiDiet";
import DietData from "../data/DietData";
import GeminiWorkout from "../ai/GeminiWorkOut";
import WorkoutData from "../data/WorkoutData";
import { useNavigate } from "react-router-dom";
import Gender from "../components/Gender";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPerson, faPersonDress } from "@fortawesome/free-solid-svg-icons";
import Age from "../components/Age";
import { toast } from "react-toastify";

const Data = () => {
    const { data, setData } = useContext(DataContext);
    const [disease, setDisease] = useState(JSON.parse(data.disease) || []);
    const [height, setHeight] = useState(data.height || 0);
    const [weight, setWeight] = useState(data.weight || 0);
    const [diet, setDiet] = useState(data.diet || "");
    const [gender, setGender] = useState(data.gender || "");
    const [dataSaved, setDataSaved] = useState(false);
    const [goal, setGoal] = useState(data.goal || "");
    const [age, setAge] = useState(data.age || 0);
    const [preferedDiet, setPreferedDiet] = useState(
        JSON.parse(data.preferedDiet) || []
    );
    const navigate = useNavigate();

    const dietList = DietData.map((cur) => cur.name);
    const k = DietData.filter((cur) => preferedDiet.includes(cur.name));
    const ids = k.map((cur) => {
        return cur.id;
    });
    const obj = ids.reduce((acc, curr) => {
        acc[curr] = 0;
        return acc;
    }, {});
    const exerciseList = WorkoutData.map((cur) => cur.name);

    // Save data to Firebase when saveData is true
    async function saveToDb(filteredDiet, filteredExercises) {
        set(ref(db, data.id), {
            id: data.id,
            username: data.username,
            height: height,
            weight: weight,
            diet: diet,
            dietIntake: JSON.stringify(obj),
            disease: JSON.stringify(disease),
            preferedDiet: JSON.stringify(filteredDiet),
            preferedWorkOut: JSON.stringify(filteredExercises),
            goal: goal,
            gender: gender,
            age: age,
        });
        const userRef = ref(db, data.id);
        const snapshot = await get(userRef);
        if (snapshot.exists()) {
            setData(snapshot.val());
            setDataSaved(true);
        }
    }

    // Trigger filtering and saving when step === 5

    const loadFilteredData = async () => {
        if (height <= 0 || weight <= 0 || age <= 0 || !diet || !gender) {
            toast.warn("Please fill all fields with valid values.");
            return;
        }
        if (weight > 0 && height > 0 && diet.length > 0 && goal.length > 0) {
            try {
                const filteredExercises = await GeminiWorkout(
                    exerciseList,
                    disease,
                    height,
                    weight,
                    goal,
                    age
                );
                const filteredDiet = await GeminiDiet(
                    dietList,
                    diet,
                    disease,
                    height,
                    weight,
                    goal,
                    age
                );
                if (!filteredDiet || !filteredExercises) {
                    toast.warn("AI response is empty. Please try again.");
                    return;
                }
                saveToDb(filteredDiet, filteredExercises); // Trigger Firebase save
            } catch (error) {
                console.error("Error fetching AI data:", error.message);
            }
        }
    };

    useEffect(() => {
        const bmi = (weight * 10000) / (height * height);
        console.log("bmi", bmi);
        if (bmi < 18.5) {
            setGoal("Gain Weight");
        } else if (bmi > 24.9) {
            setGoal("Lose Weight");
        } else {
            setGoal("Maintain Weight");
        }
    }, [weight, height]);

    if (dataSaved) {
        // Show a message or redirect the user after saving data

        navigate("/");
        // Redirect after 5 seconds
        return <div>Data Saved</div>;
    }
    return (
        <div className="main_data_div">
            <div className="dataDiv">
                <div className="data_d"> Enter your Details:</div>
                <div className="height_weight">
                    <Height setHeight={setHeight} height={height} />
                    <Weight setWeight={setWeight} weight={weight} />
                    <Age setAge={setAge} age={age} />
                </div>
                <Gender setGender={setGender} gender={gender} />
                <Diet setDiet={setDiet} diet={diet} />
                <div className="">
                    <Disease setDisease={setDisease} disease={disease} />
                </div>
            </div>
            <div className="profile">
                {gender === "male" ? (
                    <FontAwesomeIcon icon={faPerson} className="person" />
                ) : (
                    <FontAwesomeIcon icon={faPersonDress} className="person" />
                )}
                <h1 className="user_name">{"" || data.username}</h1>
                <pre className="user_data">Height: {height} cm.</pre>
                <pre className="user_data">Weight: {weight} kg.</pre>
                <pre className="user_data">Age: {age} years.</pre>
                <pre className="user_data">Diet : {diet}</pre>
                <pre className="user_data">Goal : {goal}</pre>
                <pre className="user_data">Gender : {gender}</pre>
                <pre className="user_data">
                    Disease:
                    {disease.length === 0 ? (
                        <>healthy body</>
                    ) : (
                        disease.join(",")
                    )}
                </pre>
                <button
                    className="btn2"
                    onClick={() => {
                        loadFilteredData();
                    }}>
                    Save Data
                </button>
            </div>
        </div>
    );
};

export default Data;
